import { FC } from "react";

interface IMapSectionProps {
  x: string;
  y: string;
  companyTitle: string;
}

const MapSection: FC<IMapSectionProps> = ({ x, y, companyTitle }) => {
  const src = `https://maps.google.com/maps?q=${x},${y}&hl=tr&z=15&output=embed`;

  return (
    <iframe
      src={src}
      className="w-100"
      height="450"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title={companyTitle}
    ></iframe>
  );
};

export default MapSection;
